import { render, staticRenderFns } from "./Class.vue?vue&type=template&id=2729d7df&scoped=true&lang=pug"
import script from "./Class.vue?vue&type=script&lang=js"
export * from "./Class.vue?vue&type=script&lang=js"
import style0 from "./Class.vue?vue&type=style&index=0&id=2729d7df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2729d7df",
  null
  
)

export default component.exports